const PaymentGatewayTypes = {
  // gopay: 'GoPay', // todo: dočasně pozastaveno
  csob: 'ČSOB',
  paypal: 'PayPal',
  // adyen: 'Adyen', // todo: dočasně pozastaveno
  gpwebpay: 'GP webpay',
  authorizenet: 'Authorize.Net',
  comgate: 'ComGate - all payment methods',
  comgateCreditCard: 'ComGate - credit cart',
  comgateOnline: 'ComGate - online payment methods',
};

export const getPaymentGatewayTypes = () => {
  return Object.keys(PaymentGatewayTypes).map((pg: string) => {
    return { value: pg, caption: PaymentGatewayTypes[pg] };
  });
};

export default PaymentGatewayTypes;



// WEBPACK FOOTER //
// ./src/helpers/PaymentGateways/paymentGateways.ts